import { useEffect } from 'react';
import {
    getTrackingWindow,
    injectHeadScript,
    type TrackingWindow,
} from '../util/inject-head-script';

interface GA4Props {
    id: string;
}

export const GA4Head: React.FC<GA4Props> = ({ id }) => {
    // gtag is injected after hydration (see `injectHeadScript`); a gtag/js + inline
    // config in <head> would run during parse and break document hydration.
    useEffect(() => {
        const w = getTrackingWindow();
        w.dataLayer = w.dataLayer || [];
        if (!w.gtag) {
            // Canonical gtag stub: pushes the raw `arguments` object so gtag.js reads
            // each command (`js`, `config`) exactly as Google's snippet expects.
            w.gtag = function gtagStub() {
                // eslint-disable-next-line prefer-rest-params
                (w.dataLayer as unknown[]).push(arguments);
            } as TrackingWindow['gtag'];
        }
        w.gtag('js', new Date());
        w.gtag('config', id);
        injectHeadScript(`https://www.googletagmanager.com/gtag/js?id=${id}`);
    }, [id]);

    return null;
};
